import React, { useEffect } from 'react';
import styled from 'styled-components';
import MatchSchedulingPanel from './MatchSchedulingPanel';

const MatchScheduleModal = ({
  isOpen,
  onClose,
  matchId,
  opponentName,
  teamId,
  viewerPlayerId = null,
  onSchedulingUpdated = null,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Overlay role="presentation" onClick={onClose}>
      <ModalContainer role="dialog" aria-modal="true" aria-labelledby="schedule-modal-title" onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <HeaderContent>
            <Title id="schedule-modal-title">Schedule match</Title>
            <Subtitle>vs {opponentName}</Subtitle>
          </HeaderContent>
          <CloseButton type="button" onClick={onClose} aria-label="Close">
            ×
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <MatchSchedulingPanel
            active={isOpen && !!matchId && !!teamId}
            matchId={matchId}
            teamId={teamId}
            viewerPlayerId={viewerPlayerId}
            onSchedulingUpdated={onSchedulingUpdated}
          />
        </ModalBody>
      </ModalContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px 12px;

  @media (max-width: 768px) {
    padding: 0;
    align-items: flex-end;
  }
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: min(1240px, 96vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    max-height: 92vh;
    border-radius: 16px 16px 0 0;
    max-width: 100%;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 2px solid #e0e0e0;
  background: linear-gradient(135deg, #043663 0%, #d52b1e 100%);
  color: white;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const Title = styled.h2`
  margin: 0 0 4px 0;
  font-size: 24px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Subtitle = styled.div`
  font-size: 16px;
  opacity: 0.95;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 32px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`;

const ModalBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px 20px;
  background: #f9fafb;

  @media (max-width: 768px) {
    padding: 14px 16px 18px;
  }

  @media (max-height: 700px) {
    max-height: 70vh;
    -webkit-overflow-scrolling: touch;
  }
`;

export default MatchScheduleModal;
